var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Finances",attrs:{"id":"App"}},[_c('Tabs',{staticClass:"large",attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab},on:{"nav":function($event){_vm.activeTab = $event}}}),(_vm.activeTab?._id == 1)?_c('CreditTransactions'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }